import { render, staticRenderFns } from "./AddPhotosOfBag.vue?vue&type=template&id=9dd2bada"
import script from "./AddPhotosOfBag.vue?vue&type=script&lang=js"
export * from "./AddPhotosOfBag.vue?vue&type=script&lang=js"
import style0 from "./AddPhotosOfBag.vue?vue&type=style&index=0&id=9dd2bada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports